import React, {Component} from 'react';
import TagActions from "../../actions/TagActions";
import {NotificationContainer} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

class AddTag extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tag: {
        PlotMaxValue: this.props.isMlTag || this.props.isIndexTag ? "100" : "1900",
        TagDispName: "",
        TagUnit: this.props.isMlTag || this.props.isIndexTag ? "%" : "-",
        PlotMinValue: "0",
        RejMinValue: "0",
        PlotColor: "",
        RejMaxValue: this.props.isMlTag || this.props.isIndexTag ? "100":"2000",
        DBArchive: this.props.isMlTag || this.props.isIndexTag ? "1" : "",
        TagName: this.props.isMlTag ? "ML_" : (this.props.isIndexTag ? "HI_" : ""),
        Precision: "2"
      },
      t: {
        TagVisible: "",
        PlotMaxValue: "",
        TagDispName: "",
        TagUnit: "-",
        TypeDesc: "",
        PlotMinValue: "",
        RejMinValue: "",
        TagDesc: "",
        PlotColor: "",
        TypeType: "",
        RejMaxValue: "",
        DBArchive: "",
        TagName: "",
        TagOffset: "",
        Precision: "",
        PlotLogScale: "",
        TypeUnitFactor: "",
        TypeUnit: ""
      },
      validateName: false,
      validateShortName: false,
      validatePrecision: true,
      validatePlotMin: true,
      validatePlotMax: true,
      validateRejectMin: true,
      validateRejectMax: true,
    };
    this.checkTagName = this.checkTagName.bind(this);
    this.checkTagShortName = this.checkTagShortName.bind(this);
    this.checkPrecision = this.checkPrecision.bind(this);
    this.checkPlotMin = this.checkPlotMin.bind(this);
    this.checkPlotMax = this.checkPlotMax.bind(this);
    this.checkRejectMin = this.checkRejectMin.bind(this);
    this.checkRejectMax = this.checkRejectMax.bind(this);
    this.addNewTag = this.addNewTag.bind(this);
    this.updateState = this.updateState.bind(this);
  }

  hexToRgb(hex) {
    try{
      let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
  
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }catch(e){
      console.log('hexToRgb function in AddTag ',e)
    }
  }

  checkTagName() {
    try{
      const tagName = this.state.tag.TagName;
      const pattern = "[A-Za-z]{1,32}";
      let isFieldValid = false;
      if (tagName.trim() !== '') {
        if (tagName.match(pattern)) {
          isFieldValid = true;
          this.setState({validateName: true});
          document.getElementById('TagName').className = "form-control form-control-sm mb-5";
          document.getElementById('tagNameError').style.display = "none";
        } else {
          document.getElementById('TagName').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('tagNameError').style.display = "block";
          document.getElementById('tagNameError').innerHTML = " Invalidate Tag Name.";
          isFieldValid = false;
          this.setState({validateName: false});
        }
      } else {
        document.getElementById('TagName').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('tagNameError').style.display = "block";
        document.getElementById('tagNameError').innerHTML = " Tag Name can not be empty.";
        isFieldValid = false;
        this.setState({validateName: false});
      }
      return isFieldValid;
    }catch(e){
      console.log('checkTagName function in AddTag ',e)
    }
  }

  checkTagShortName() {
    try{
      const tagShortName = this.state.tag.TagDispName;
      const pattern = "[A-Za-z]{1,32}";
      let isFieldValid = false;
      if (tagShortName.trim() !== '') {
        if (tagShortName.match(pattern)) {
          isFieldValid = true;
          this.setState({validateShortName: true});
          document.getElementById('TagDispName').className = "form-control form-control-sm mb-5";
          document.getElementById('tagShortNameError').style.display = "none";
        } else {
          document.getElementById('TagDispName').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('tagShortNameError').style.display = "block";
          document.getElementById('tagShortNameError').innerHTML = " Invalidate Display name.";
          isFieldValid = false;
          this.setState({validateShortName: false});
        }
      } else {
        document.getElementById('TagDispName').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('tagShortNameError').style.display = "block";
        document.getElementById('tagShortNameError').innerHTML = "Display name can not be empty.";
        isFieldValid = false;
        this.setState({validateShortName: false});
      }
      return isFieldValid;
    }catch(e){
      console.log('checkTagShortName function in AddTag ',e)
    }
  }

  checkPrecision() {
    try{
      const precision = this.state.tag.Precision;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      let isFieldValid = false;
      if (precision.trim() !== '') {
        if (pattern.test(precision)) {
          isFieldValid = true;
          this.setState({validatePrecision: true});
          document.getElementById('Precision').className = "form-control form-control-sm mb-5";
          document.getElementById('precisionError').style.display = "none";
        } else {
          document.getElementById('Precision').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('precisionError').style.display = "block";
          document.getElementById('precisionError').innerHTML = " Invalidate Precision value.";
          isFieldValid = false;
          this.setState({validatePrecision: false});
        }
      } else {
        document.getElementById('Precision').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('precisionError').style.display = "block";
        document.getElementById('precisionError').innerHTML = " Precision  can not be empty.";
        isFieldValid = false;
        this.setState({validatePrecision: false});
      }
      return isFieldValid;
    }catch(e){
      console.log('checkPrecision function in AddTag ',e)
    }
  }

  checkPlotMin() {
    try{
      const plotMin = this.state.tag.PlotMinValue;
      const plotMax = this.state.tag.PlotMaxValue;
      let isFieldValid = false;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      if (plotMin.trim() !== '') {
        if (pattern.test(plotMin)) {
          if (parseFloat(plotMin) >= parseFloat(plotMax)) {
            isFieldValid = false;
            this.setState({validatePlotMin: false});
            document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5 border border-danger";
            document.getElementById('plotMinError').style.display = "block";
            document.getElementById('plotMinError').innerHTML = " Plot min value can not be equal / greater than Plot max value.";
          } else {
            if (document.getElementById('plotMaxError').style.display === "block") {
              document.getElementById('plotMaxError').style.display = "none";
              document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5";
              this.setState({validatePlotMax: true});
            }
            isFieldValid = true;
            this.setState({validatePlotMin: true});
            document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5";
            document.getElementById('plotMinError').style.display = "none";
          }
        } else {
          document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('plotMinError').style.display = "block";
          document.getElementById('plotMinError').innerHTML = " Invalidate Plot min value.";
          isFieldValid = false;
          this.setState({validatePlotMin: false});
        }
      } else {
        document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('plotMinError').style.display = "block";
        document.getElementById('plotMinError').innerHTML = " Plot min can not be empty.";
        isFieldValid = false;
        this.setState({validatePlotMin: false});
      }
      return isFieldValid;
    }catch(e){
      console.log('checkPlotMin function in AddTag ',e)
    }
  }

  checkPlotMax() {
    try{
      const plotMax = this.state.tag.PlotMaxValue;
      const plotMin = this.state.tag.PlotMinValue;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      let isFieldValid = false;
      if (plotMax.trim() !== '') {
        if (pattern.test(plotMax)) {
          if (parseFloat(plotMax) <= parseFloat(plotMin)) {
            isFieldValid = false;
            this.setState({validatePlotMax: false});
            document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
            document.getElementById('plotMaxError').style.display = "block";
            document.getElementById('plotMaxError').innerHTML = " Plot max value can not be equal / less than Plot min value.";
          } else {
            if (document.getElementById('plotMinError').style.display === "block") {
              document.getElementById('plotMinError').style.display = "none";
              document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5";
              this.setState({validatePlotMin: true});
            }
            isFieldValid = true;
            this.setState({validatePlotMax: true});
            document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5";
            document.getElementById('plotMaxError').style.display = "none";
          }
        } else {
          document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('plotMaxError').style.display = "block";
          document.getElementById('plotMaxError').innerHTML = " Invalidate Plot max value.";
          isFieldValid = false;
          this.setState({validatePlotMax: false});
  
        }
      } else {
        document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('plotMaxError').style.display = "block";
        document.getElementById('plotMaxError').innerHTML = " Plot max  can not be empty.";
        isFieldValid = false;
        this.setState({validatePlotMax: false});
      }
      return isFieldValid;
    }catch(e){
      console.log('checkTagName function in AddTag ',e)
    }
  }

  checkRejectMin() {
    try{
      const rejectMin = this.state.tag.RejMinValue;
      const rejectMax = this.state.tag.RejMaxValue;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      let isFieldValid = false;
      if (rejectMin.trim() !== '') {
        if (pattern.test(rejectMin)) {
          if (parseFloat(rejectMin) >= parseFloat(rejectMax)) {
            isFieldValid = false;
            this.setState({validateRejectMin: false});
            document.getElementById('RejMinValue').className = "form-control form-control-sm mb-5 border border-danger";
            document.getElementById('rejectMinError').style.display = "block";
            document.getElementById('rejectMinError').innerHTML = " Reject min value can not be equal / greater than Reject max value.";
          } else {
            if (document.getElementById('rejectMaxError').style.display === "block") {
              document.getElementById('rejectMaxError').style.display = "none";
              document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5";
              this.setState({validateRejectMax: true});
            }
            isFieldValid = true;
            this.setState({validateRejectMin: true});
            document.getElementById('RejMinValue').className = "form-control form-control-sm mb-5";
            document.getElementById('rejectMinError').style.display = "none";
          }
        } else {
          document.getElementById('Precision').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('rejectMinError').style.display = "block";
          document.getElementById('rejectMinError').innerHTML = " Invalidate Reject min value.";
          isFieldValid = false;
          this.setState({validateRejectMin: false});
        }
      } else {
        document.getElementById('RejMinValue').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('rejectMinError').style.display = "block";
        document.getElementById('rejectMinError').innerHTML = " Reject min can not be empty.";
        isFieldValid = false;
        this.setState({validateRejectMin: false});
      }
      return isFieldValid;
    }catch(e){
      console.log('checkRejectMin function in AddTag ',e)
    }
  }

  checkRejectMax() {
    try{
      const rejectMin = this.state.tag.RejMinValue;
      const rejectMax = this.state.tag.RejMaxValue;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      let isFieldValid = false;
      if (rejectMax.trim() !== '') {
        if (pattern.test(rejectMax)) {
          if (parseFloat(rejectMax) <= parseFloat(rejectMin)) {
            isFieldValid = false;
            this.setState({validateRejectMax: false});
            document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
            document.getElementById('rejectMaxError').style.display = "block";
            document.getElementById('rejectMaxError').innerHTML = " Reject max value can not be equal / less than Reject min value.";
          } else {
            if (document.getElementById('rejectMinError').style.display === "block") {
              document.getElementById('rejectMinError').style.display = "none";
              document.getElementById('RejMinValue').className = "form-control form-control-sm mb-5";
              this.setState({validateRejectMin: true});
            }
            isFieldValid = true;
            this.setState({validateRejectMax: true});
            document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5";
            document.getElementById('rejectMaxError').style.display = "none";
          }
        } else {
          document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('rejectMaxError').style.display = "block";
          document.getElementById('rejectMaxError').innerHTML = " Invalidate Reject max value.";
          isFieldValid = false;
          this.setState({validateRejectMax: false});
  
        }
  
      } else {
        document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('rejectMaxError').style.display = "block";
        document.getElementById('rejectMaxError').innerHTML = " Reject max can not be empty.";
        isFieldValid = false;
        this.setState({validateRejectMax: false});
      }
      return isFieldValid;
    }catch(e){
      console.log('checkRegexMax function in AddTag ',e)
    }
  }

  addNewTag(event) {
    try{
      event.preventDefault();
      if (this.checkTagName() &&
              this.checkTagShortName() &&
              this.checkPrecision() &&
              this.checkPlotMin() &&
              this.checkPlotMax() &&
              this.checkRejectMin() &&
              this.checkRejectMax()) {
        let tg = this.state.t;
        tg.PlotMaxValue = this.state.tag.PlotMaxValue;
        tg.TagDispName = this.state.tag.TagDispName;
        tg.TagUnit = this.state.tag.TagUnit;
        tg.PlotMinValue = this.state.tag.PlotMinValue;
        tg.RejMinValue = this.state.tag.RejMinValue;
        const color = this.hexToRgb(this.state.tag.PlotColor.substr(1, this.state.tag.PlotColor.length));
        tg.PlotColor = color !== null ? color.r + "," + color.g + "," + color.b : "0,0,0";
        tg.RejMaxValue = this.state.tag.RejMaxValue;
        tg.DBArchive = this.state.tag.DBArchive;
        tg.TagName = this.state.tag.TagName;
        tg.Precision = this.state.tag.Precision;
        this.setState({t: tg});
        let tt = this.state.t;
        tt.TypeDesc = this.state.tag.TagName.trim();
        tt.TagDesc = this.state.tag.TagName.trim();
        tt.TypeType = "100";
        tt.TagOffset = "0";
        tt.PlotLogScale = "1";
        tt.TypeUnitFactor = "1";
        tt.TypeUnit = this.state.tag.TagUnit;
        tt.TagVisible = "1";
        let DBArchive = document.getElementById("DBArchive");
        if(this.props.isMlTag || this.props.isIndexTag){
          DBArchive.checked={
            checked:true
          }
        }else{
          DBArchive.checked === true ? tt.DBArchive = "1" : tt.DBArchive = "0";
        }
        // DBArchive.checked === true ? tt.DBArchive = "1" : tt.DBArchive = "0";
        this.setState({t: tt});
        const isOutputTag = this.props.isMlTag || this.props.isIndexTag;
        TagActions.insertTag(this.state.t,isOutputTag);
        this.props.hideModal();
      }
    }catch(e){
      console.log('addNewTag function in AddTag ',e)
    }
  }

  updateState(event) {
    try{
      const field = event.target.id;
      const value = event.target.value;
      if((this.props.isMlTag || this.props.isIndexTag) && field === 'TagName'){
        if(value.length>=3){
          let t = this.state.tag;
          t[field] = value;
          this.setState({tag: t});
        }
      }else{
        let t = this.state.tag;
        t[field] = value;
        this.setState({tag: t});
      }
    }catch(e){
      console.log('updateState function in AddTag ',e)
    }
  }

  render() {
    return (
            <form className="">
              <div className="row mt-10">
                <div className="col-sm-6">
                  <div className="row">
                    <label className="control-label col-sm-5" htmlFor="TagName">Tag Name : <span
                            className="text-danger">*</span></label>
                    <div className="col-sm-7">
                      <input onChange={(event) => {
                        this.updateState(event);
                        this.checkTagName();
                      }} value={this.state.tag.TagName} type="text" className="form-control form-control-sm mb-5" id="TagName"
                             pattern="[A-Za-z]{1,32}"
                             autoFocus
                             maxLength={"100"}
                      />
                      <div id="tagNameError" style={{display: 'none'}} className="invalid-feedback">

                      </div>
                    </div>
                  </div>
                  <div className="row" hidden={this.props.isMlTag || this.props.isIndexTag}>
                    <label className="control-label col-sm-5" htmlFor="TagUnit">Unit :</label>
                    <div className="col-sm-7">
                      <input maxLength={"21"} onChange={(event) => {
                        this.updateState(event)
                      }} disabled={this.props.isMlTag || this.props.isIndexTag} value={this.state.tag.TagUnit} type="text" className="form-control form-control-sm mb-5" id="TagUnit" placeholder=""/>
                    </div>
                  </div>
                  <div className="row" hidden={this.props.isMlTag || this.props.isIndexTag}>
                    <label className="control-label col-sm-5" htmlFor="PlotMinValue">Plot Min : <span
                            className="text-danger">*</span></label>
                    <div className="col-sm-7">
                      <input onChange={(event) => {
                        this.updateState(event);
                        this.checkPlotMin();
                      }} value={this.state.tag.PlotMinValue} type="number" className="form-control form-control-sm mb-5"
                             id="PlotMinValue"
                             pattern="^\d+(\.\d+)?$"
                              />
                      <div id="plotMinError" style={{display: 'none'}} className="invalid-feedback">

                      </div>
                    </div>
                  </div>
                  <div className="row" hidden={this.props.isMlTag || this.props.isIndexTag}>
                    <label className="control-label col-sm-5" htmlFor="RejMinValue">Reject Min : <span
                            className="text-danger">*</span></label>
                    <div className="col-sm-7">
                      <input onChange={(event) => {
                        this.updateState(event);
                        this.checkRejectMin();
                      }} value={this.state.tag.RejMinValue} type="number" className="form-control form-control-sm mb-5"
                             id="RejMinValue"
                             pattern="^\d+(\.\d+)?$"
                              />
                      <div id="rejectMinError" style={{display: 'none'}} className="invalid-feedback">

                      </div>
                    </div>
                  </div>
                  <div className="row" hidden={this.props.isMlTag || this.props.isIndexTag}>
                    <label className="control-label col-sm-5" >Color :</label>
                    <div className="col-sm-7">
                      <input onChange={(event) => {
                        this.updateState(event)
                      }} type="color" className="form-control form-control-sm mb-5" id="PlotColor" placeholder=""/>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="row">
                    <label className="control-label col-sm-5" htmlFor="TagDispName">Display Name : <span
                            className="text-danger">*</span></label>
                    <div className="col-sm-7">
                      <input onChange={(event) => {
                        this.updateState(event);
                        this.checkTagShortName();
                      }} type="text" className="form-control form-control-sm mb-5" id="TagDispName"
                             pattern="[A-Za-z]{1,32}"
                             maxLength={"100"}        
                      />
                      <div id="tagShortNameError" style={{display: 'none'}} className="invalid-feedback">

                      </div>
                    </div>
                  </div>
                  <div className="row" hidden={this.props.isMlTag || this.props.isIndexTag}>
                    <label className="control-label col-sm-5" htmlFor="Precision">Precision : <span
                            className="text-danger">*</span></label>
                    <div className="col-sm-7">
                      <input onChange={(event) => {
                        this.updateState(event);
                        this.checkPrecision();
                      }} type="number" min="1" value={this.state.tag.Precision}
                             className="form-control form-control-sm mb-5" id="Precision"
                             pattern="^\d+(\.\d+)?$"
                      />
                      <div id="precisionError" style={{display: 'none'}} className="invalid-feedback">
                      </div>
                    </div>
                  </div>
                  <div className="row" hidden={this.props.isMlTag || this.props.isIndexTag}> 
                    <label className="control-label col-sm-5" htmlFor="PlotMaxValue">Plot Max : <span
                            className="text-danger">*</span></label>
                    <div className="col-sm-7">
                      <input onChange={(event) => {
                        this.updateState(event);
                        this.checkPlotMax();
                      }} disabled={this.props.isMlTag || this.props.isIndexTag} type="number" value={this.state.tag.PlotMaxValue} className="form-control form-control-sm mb-5"
                             id="PlotMaxValue"
                             pattern="^\d+(\.\d+)?$"
                              />
                      <div id="plotMaxError" style={{display: 'none'}} className="invalid-feedback">
                      </div>
                    </div>
                  </div>
                  <div className="row" hidden={this.props.isMlTag || this.props.isIndexTag}>
                    <label className="control-label col-sm-5" htmlFor="RejMaxValue">Reject Max : <span
                            className="text-danger">*</span></label>
                    <div className="col-sm-7">
                      <input onChange={(event) => {
                        this.updateState(event);
                        this.checkRejectMax();
                      }} disabled={this.props.isMlTag || this.props.isIndexTag} type="number" value={this.state.tag.RejMaxValue} className="form-control form-control-sm mb-5"
                             id="RejMaxValue"
                             pattern="^\d+(\.\d+)?$"
                              />
                      <div id="rejectMaxError" style={{display: 'none'}} className="invalid-feedback">
                      </div>
                    </div>
                  </div>
                  <div className="row" hidden={this.props.isMlTag || this.props.isIndexTag}>
                    <div className=" form-check pl-1 pl-15">
                      <input type="checkbox" hidden="true" className="form-check-input" id="DBArchive"/>
                      <label className="form-check-label" htmlFor="DBArchive">Archive</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row ">
                <div className="col-sm-offset-2 col-sm-12">
                  <button onClick={(event) => {
                    this.addNewTag(event)
                  }}
                          className="btn btn-sm btn-primary mt-5 float-right">Save
                  </button>
                </div>
              </div>
              <NotificationContainer/>
            </form>
    )
  }
}

export default AddTag;